import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Reproduction et publication",
  title: "Unité de Reproduction des Travaux Académiques",
  banner_image: "/media/museum-publications.jpg",
  intro:
    "L'Unité de Reproduction est la plateforme officielle de dépôt et de publication des travaux académiques (mémoires, TFC) des anciens étudiants souhaitant valoriser leurs recherches à travers les PUSIC.",
  presentation:
    "Cette plateforme accueille prochainement les soumissions des anciens étudiants désirant publier leurs mémoires ou Travaux de Fin de Cycle (TFC). Chaque publication passe par un processus de validation par le Secrétariat Général à la Recherche et un Bon à Imprimer (B.A.T) officiel.\n\nLe contenu détaillé (formulaire de dépôt, conditions d'éligibilité, catalogue des travaux publiés) sera disponible prochainement.",
};

export default function UniteReproduction() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/pusic.reproduction").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);

  return (
    <div data-testid="unite-reproduction-page">
      <section className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-4xl">{content.title}</h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-dark">Présentation</div>
            <span className="divider-gold mt-3" />
            <p className="mt-6 text-lg text-slate-700 leading-relaxed whitespace-pre-line">{content.intro}</p>
            <div className="mt-8 paper-card p-6 bg-unisic-blue/5 border-l-4 border-unisic-gold">
              <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-line">{content.presentation}</p>
            </div>
          </div>
          <aside className="paper-card p-6 h-fit">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-unisic-blue text-white mb-3">
              <Printer className="w-5 h-5" />
            </div>
            <div className="eyebrow eyebrow-dark">Bientôt disponible</div>
            <span className="divider-gold mt-2" />
            <p className="mt-4 text-sm text-slate-700 leading-relaxed">
              Formulaire de soumission, catalogue des mémoires publiés, statuts de validation. Restez informés via nos actualités.
            </p>
          </aside>
        </div>
      </section>
    </div>
  );
}
